export function setupScrollPositionEvents() {
    window.addEventListener("scroll", function () {
        var scrollPosition = window.scrollY;
        var stickyCTAshouldHide = document.querySelector(
            ".hide-join-us-figure"
        );
        var body = document.body;
        var viewportWidth = window.innerWidth;

        if (
            viewportWidth < 768 &&
            stickyCTAshouldHide &&
            scrollPosition > stickyCTAshouldHide.offsetTop
        ) {
            body.classList.add("join-us-figure-hidden");
        } else {
            body.classList.remove("join-us-figure-hidden");
        }

        // Add "scrolling-down" class when scrolling down
        if (scrollPosition > this.lastScrollPosition) {
            document.body.classList.add("scrolling-down");
            document.body.classList.remove("scrolling-up");
        }

        // Add "scrolling-up" class when scrolling up
        else if (scrollPosition < this.lastScrollPosition) {
            document.body.classList.add("scrolling-up");
            document.body.classList.remove("scrolling-down");
        }

        // Check if scrolled passed above the fold content
        // and add "below-the-fold" class
        var foldHeight = window.innerHeight;
        if (scrollPosition > foldHeight) {
            document.body.classList.add("below-the-fold");
        } else {
            document.body.classList.remove("below-the-fold");
        }

        // Check if scrolled passed above the fold content
        // and add "below-the-fold" class
        var halfFoldHeight = window.innerHeight / 4;
        if (scrollPosition > halfFoldHeight) {
            document.body.classList.add("scrolled-a-bit");
        } else {
            document.body.classList.remove("scrolled-a-bit");
        }

        this.lastScrollPosition = scrollPosition;
    });
}
